import { INPUT_CHANGE, LANDING_FROM_REQUEST_ASYNC, LANDING_FROM_UPDATE_ASYNC } from './constants'

const getLandingPages = () => ({ type: LANDING_FROM_REQUEST_ASYNC.INITIATE })
const getLandingPagesCancel = () => ({
  type: LANDING_FROM_REQUEST_ASYNC.CANCEL,
})
export const getLandingPagesSuccess = (data) => ({
  type: LANDING_FROM_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getLandingPagesError = (error) => ({
  type: LANDING_FROM_REQUEST_ASYNC.ERROR,
  error,
})

const updLandingPages = () => ({ type: LANDING_FROM_UPDATE_ASYNC.INITIATE })
const updLandingPagesCancel = () => ({ type: LANDING_FROM_UPDATE_ASYNC.CANCEL })
export const updLandingPagesSuccess = (data) => ({
  type: LANDING_FROM_UPDATE_ASYNC.SUCCESS,
  payload: { data },
})
export const updLandingPagesError = (error) => ({
  type: LANDING_FROM_UPDATE_ASYNC.ERROR,
  error,
})

const inputChangeHandler = (mainKey, objKey, value, locale) => ({
  type: INPUT_CHANGE,
  payload: {
    mainKey,
    objKey,
    value,
    locale,
  },
})

export default {
  // to props
  getLandingPages,
  getLandingPagesCancel,
  updLandingPages,
  updLandingPagesCancel,
  inputChangeHandler,
}
